import React from "react";
import { Alert, Form, Icon, Button, Row, Col, Upload } from "antd";
import { connect } from "react-redux";

import { get } from "lodash";

import { etmfDocumentSchemaUpload } from "../../api/requests";

import classes from "./DocumentsEtmfSchema.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";

class DocumentEtmfSchemaUpload extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      sites: [],
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          document.document_file = values.document_file.file;

          const formData = new FormData();

          if (values.document_file && values.document_file.file) {
            formData.append("document_file", values.document_file.file);
          }

          await etmfDocumentSchemaUpload(formData);

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", "Error"),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};

            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: [
                    new Error(
                      JSON.stringify(
                        get(e, `response.data.errors.${errorFieldKey}`)
                      )
                    ),
                  ],
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const {
      getFieldDecorator,
      getFieldValue,
      setFieldsValue,
    } = this.props.form;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">{this.props.i18n.t("NamespaceDocumentsEditor:eTMF document schema upload")}</h4>

          <Row gutter={12}>
            <Col>
              <label>
                <Form.Item>
                  {getFieldDecorator("document_file", {
                    initialValue: get(this.props, "document_file", ""),
                  })(
                    <Upload
                      accept=".csv"
                      action=""
                      beforeUpload={() => false}
                      multiple={false}
                      fileList={get(
                        this.props.form.getFieldValue("document_file"),
                        "fileList",
                        []
                      ).slice(-1)}
                    >
                      <Button>
                        <Icon type="upload" />
                        {!this.props.form.getFieldValue("document_file") &&
                        this.props.url ? (
                          this.props.i18n.t("Change file")
                        ) : (
                          <span>
                            {this.props.i18n.t(
                              "NamespaceDocumentsEditor:eTMF document schema upload"
                            )}{" "}
                            <span style={{ color: "#f00" }}>*</span>
                          </span>
                        )}
                      </Button>
                    </Upload>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapperUpdate}>
            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t("Cancel")}
            </Button>

            <Button
              type="primary"
              size="large"
              htmlType="submit"
              className={classes.submitButton}
            >
              {this.props.i18n.t("Save")}
              {isLoading && <Icon type="loading" />}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = { logout };

export default Form.create({ name: "DocumentEtmfSchemaUpload" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(DocumentEtmfSchemaUpload))
);



// WEBPACK FOOTER //
// ./src/containers/DocumentsEtmfSchema/DocumentEtmfSchemaUpload.js